package one.healthium.insights.ui.player

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import one.healthium.player.VideoPlayer

interface VideoPlayerEventDelegate {
    fun onBackClicked()
}

@Composable
fun VideoPlayerScreen(
    url: String,
    eventDelegate: VideoPlayerEventDelegate,
) {
    VideoPlayerInternal(url)
}

@Composable
private fun VideoPlayerInternal(url: String) {
    var isLoading by remember { mutableStateOf(false) }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(color = Color.Black),
        contentAlignment = Alignment.Center,
    ) {
        VideoPlayer(
            modifier = Modifier.fillMaxSize().navigationBarsPadding(),
            url = url,
            bufferCallback = {
                isLoading = it
            }
        )
        if (isLoading) {
            CircularProgressIndicator()
        }
    }
}